import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import logoCentre from '../assets/images/logoCentre.PNG';
import menuIcon from '../assets/images/menu.png';
import closeIcon from '../assets/images/fermer.png';
import { Link } from 'react-router-dom';
import { getLang } from '../environnement';
import { useDispatch, useSelector } from 'react-redux';
import { langSelector, setLang } from '../store/langSlice';
import Lang from '../components/lang';

function ItemNavBar({
  item,
  isActive=false,
  menu=false,
  link,
  lang
}) {
  if (menu) {
    return (
      <Link to={link}>
        <div
          className={`font-inter font-medium text-center text-white hover:bg-primary py-2 cursor-pointer text-lg w-full ${isActive && 'bg-primary'}`}
          style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}
        >
          {item}
        </div>
      </Link>
    );
  } else {
    return (
      <Link
        to={link}
        className={`font-inter font-medium hover:text-primary cursor-pointer mx-5 text-lg ${isActive && 'text-primary'}`}
        style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}
      >
        {item}
      </Link>
    );
  }
}


export default function Header({
  activeItem
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const lang = useSelector(langSelector);

  const navBarItems = [
    {id: 1, item: getLang(lang).header.acceuil, link: '/'},
    {id: 2, item: getLang(lang).header.aProposDuCentre, link: '/apropos-centre'},
    // {id: 3, item: getLang(lang).header.demandeSalle, link: '/demande-salle'},
    {id: 4, item: getLang(lang).header.nousContacter, link: '/nous-contacter'},
  ];

  return (
    <>
      <div className='flex justify-center w-full' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='flex justify-between items-center ml-6 mr-10 w-full 3xl:w-[1200px]'>
          <Link to='/'>
            <img src={logoCentre} alt='logo center' className='w-[200px]' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}/>
          </Link>
          <div className='sm:flex flex-wrap justify-center hidden'>
            {navBarItems.map((itemdata) => {
              return (
                <ItemNavBar
                  key={itemdata.id}
                  item={itemdata.item}
                  isActive={activeItem === itemdata.item}
                  link={itemdata.link}
                  lang={lang}
                />
              )
            })}
          </div>
          <div className='hidden sm:block'>
            <Lang lang={lang} />
            {/* <div
              className='rounded-[20px] bg-primary hover:bg-primaryDark pb-2 px-7 cursor-pointer'
              onClick={() => {
                dispatch(setLang(lang))
              }}
            >
              <p className='text-white font-regular text-lg relative top-0.5'>{getLang(lang).header.lang}</p>
            </div> */}
          </div>
          <div className='sm:hidden relative left-3'>
            <IconButton
              onClick={() => setIsMenuOpen((isMenuOpenPrevState) => !isMenuOpenPrevState)}
            >
              <div className='rounded-full bg-primary p-4'>
                <img src={menuIcon} alt='menu' className={`w-5 ${isMenuOpen && 'hidden'}`}/>
                <img src={closeIcon} alt='menu' className={`w-5 ${!isMenuOpen && 'hidden'}`}/>
              </div>
            </IconButton>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className='shadow h-60 w-full bg-secondary sm:hidden border-4 border-primary'>
          {navBarItems.map((itemdata) => {
            return (
              <ItemNavBar
                key={itemdata.id}
                item={itemdata.item}
                isActive={activeItem === itemdata.item}
                link={itemdata.link}
                menu
              />
            )
          })}
          <div onClick={() => {
            dispatch(setLang(lang === 'en' ? 'fr' : 'en'));
            setIsMenuOpen(false);
          }}>
            <ItemNavBar item={getLang(lang).header.lang} setOpenMenu={setIsMenuOpen} menu />
          </div>
        </div>
      )}
      <div className='flex justify-center w-full bg-primary' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='w-full bg-primary flex justify-between items-center px-10 3xl:px-0 3xl:w-[1200px]'>
          <p className='text-white font-inter font-semiBold text-sm xxs:text-lg text-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).header.portail}</p>
          <p className='hidden sm:inline text-white font-inter font-semiBold text-lg text-end' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).header.portailOtherLang}</p>
          {/* <p className='sm:hidden text-white font-inter font-semiBold text-lg text-end'>M.T.C</p> */}
        </div>
      </div>
    </>
  );
}
